import { Component, Input } from '@angular/core';
import { PinterestElementPreviewFragment } from '@/core/graphql/graphql';

@Component({
  selector: 'cosmos-pinterest-element-preview',
  templateUrl: './pinterest-element-preview.component.html',
  styleUrls: ['./pinterest-element-preview.component.scss'],
})
export class PinterestElementPreviewComponent {
  @Input() public element: PinterestElementPreviewFragment;
}
